import {AfterViewInit, Component, Inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {
    IPortfolioResultResponse,
    RebalanceAction,
    SecurityTradeActionNote
} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {WINDOW} from '@irb/app.tokens';

@Component({ standalone: false,
    selector: 'irb-dialog-pr-explanation',
    templateUrl: './dialog-pr-explanation.component.html',
    styleUrls: ['./dialog-pr-explanation.component.scss', '../../irb-common/styles/dialog.scss']
})
export class DialogPrExplanationComponent implements OnInit, AfterViewInit {

    rebalanceActionData: MatTableDataSource<RebalanceAction>;
    securityTradeActionNoteData: MatTableDataSource<SecurityTradeActionNote>;

    rebalanceActionColumns = ['category', 'description'];
    securityTradeActionNoteColumns = ['securitySymbol', 'category', 'description'];

    @ViewChildren(MatSort) sort: QueryList<MatSort>;

    constructor(
        private dialogRef: MatDialogRef<DialogPrExplanationComponent>,
        @Inject(WINDOW) private window: Window,
        @Inject(MAT_DIALOG_DATA) private data: Partial<IPortfolioResultResponse>
    ) {
    }

    ngOnInit(): void {
        if (this.showRebalanceTable) {
            this.rebalanceActionData = new MatTableDataSource(this.data.rebalAccReportList);
        }
        if (this.showSecurityTradeTable) {
            this.securityTradeActionNoteData = new MatTableDataSource(this.data.rebalSecReportList);
        }
    }

    ngAfterViewInit(): void {
        const sortArray = this.sort.toArray();
        if (this.showRebalanceTable) {
            this.rebalanceActionData.sort = sortArray[0];
        }
        if (this.showSecurityTradeTable) {
            this.securityTradeActionNoteData.sort = sortArray[this.showRebalanceTable ? 1 : 0];
        }
    }

    get portfolioName(): string {
        return this.data.portfolioName;
    }

    get showRebalanceTable(): boolean {
        return this.data.rebalAccReportList && this.data.rebalAccReportList.length > 0;
    }

    get showSecurityTradeTable(): boolean {
        return this.data.rebalSecReportList && this.data.rebalSecReportList.length > 0;
    }

    openTutorial() {
        this.window.open('../irebal/resources/tutorials/index.jsp?#lesson5_id200', '_blank');
    }

    close() {
        this.dialogRef.close();
    }
}
